<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useAuthStore } from "@/stores/auth";
import useEncryption from "@/utils/helpers/encryption";

const uiStore = useUiStore();
const authStore = useAuthStore();
const emit = defineEmits(["refresh", "removeBackground", "updateSitePassword"]);
const company_id = useCompanyStore().companyId;
const user = ref(JSON.parse(localStorage.getItem("user")));

const { usePasswordVisibility } = useEncryption();
const { passwordInputType, passwordIconClass, togglePassword } = usePasswordVisibility();

const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);

let siteData = ref(null);
let password = ref(null);
let isSubmitted = ref(false);

const resetStoreData = () => {
  uiStore.resetModalStore();
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = { email: user.value.user.email, password: password.value, company_id };
  authStore
    .checkUserPassword(data)
    .then(() => {
      resetStoreData();
      emit("updateSitePassword", siteData.value);
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

onBeforeMount(() => {
  if (getModalInfo.value && getModalInfo.value.data_type == "site" && getModalAction.value == "check_user_password") {
    siteData.value = getModalInfo.value;
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'check_user_password'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Enter your login password </template>

    <template #body>
      <div class="mb-3">
        <DInput
          :value="password"
          @input="password = $event.target.value"
          :type="passwordInputType"
          label="Password"
          width="100%"
        />
        <span class="showPassword" @click="togglePassword"><i :class="passwordIconClass"></i></span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!password || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Continue <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
